import React from "react";
import { Typography, Card, Space, Flex, Button, List } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, GithubOutlined, GlobalOutlined, InstagramOutlined, XOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
    const navigate = useNavigate()
    return (
        <>
            <Flex align="center" gap={10}>
                <ArrowLeftOutlined onClick={() => navigate(-1)} />
                <Text strong style={{ fontSize: "16px" }}>Privacy Policy</Text>
            </Flex> <br />

            <Card>
                <Space direction="vertical" size="large" style={{ width: "100%" }}>
                    {/* <Title level={2}>Privacy Policy</Title> */}
                    <Text type="secondary">
                        Last updated: {new Date().toLocaleDateString()}
                    </Text>

                    <Paragraph>
                        Kamuska ("we", "our", or "us") respects your privacy. This Privacy
                        Policy explains how we collect, use, and protect your information when
                        you use the Kamuska application.
                    </Paragraph>

                    <Title level={4}>1. Information We Collect</Title>
                    <Paragraph>
                        We may collect the following information:
                    </Paragraph>
                    <List>
                        <List.Item>Personal details such as name, phone number, and email</List.Item>
                        <List.Item>Location data for delivery services</List.Item>
                        <List.Item>Order and transaction details</List.Item>
                        <List.Item>Device and usage data</List.Item>
                    </List>

                    <Title level={4}>2. How We Use Your Information</Title>
                    <List>
                        <List.Item>To process and deliver orders</List.Item>
                        <List.Item>To connect users with delivery partners</List.Item>
                        <List.Item>To improve application performance</List.Item>
                        <List.Item>To provide customer support</List.Item>
                    </List>

                    <Title level={4}>3. Data Sharing</Title>
                    <Paragraph>
                        We do not sell your personal data. Information is shared only with
                        service providers required to fulfill orders.
                    </Paragraph>

                    <Title level={4}>4. Data Security</Title>
                    <Paragraph>
                        We implement reasonable security practices to protect your data.
                        However, no system is completely secure.
                    </Paragraph>

                    <Title level={4}>5. Your Rights</Title>
                    <Paragraph>
                        You may request access, correction, or deletion of your data by
                        contacting us.
                    </Paragraph>

                    <Title level={4}>6. Changes to This Policy</Title>
                    <Paragraph>
                        We may update this Privacy Policy from time to time. Updates will be
                        posted on this page.
                    </Paragraph>

                    <Title level={4}>7. Contact Us</Title>

                    <Space>
                        Email: <Link to="mailto:kamuskafoods@gmail.com">kamuskafoods@gmail.com</Link>
                    </Space>
                    <Flex align='center' gap={5}>
                        <Button href="https://instagram.com/kamuska.in"><InstagramOutlined /></Button> &nbsp;
                        <Button href="/"> <GlobalOutlined /> </Button>&nbsp;
                        <Button href="https://github.com/kamuskafoods"> <GithubOutlined /> </Button> &nbsp;
                        <Button href="https://x.com/kamuskafoods"> <XOutlined /> </Button>
                    </Flex>
                </Space>
            </Card>
        </>
    );
};

export default PrivacyPolicy;
